import React, {
  type ErrorInfo,
  type PropsWithChildren,
  type ReactElement,
} from "react";

interface ErrorBoundaryState {
  error: Error | undefined;
}

interface ErrorBoundaryProps extends PropsWithChildren {
  fallback: (error: Error) => ReactElement;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error: error });
  }

  render() {
    if (this.state.error) {
      return this.props.fallback(this.state.error);
    }
    return this.props.children;
  }
}
